<template>
  <v-card class="accounts-dashboard-card">
    <section class="accounts-stats-grid oms-list-stats">
      <StatCard
        class="accounts-stat-card accounts-stat-card--total oms-list-stat-card"
        label="Total Jobs"
        :value="dashboard.totalData"
        caption="Account records"
        icon="dashboard"
        variant="primary"
      />

      <StatCard
        class="accounts-stat-card accounts-stat-card--ongoing oms-list-stat-card"
        label="Ongoing Jobs"
        :value="dashboard.onGoingData"
        caption="Open finance work"
        icon="trending_up"
        variant="blue"
      />
    </section>
    <SelectCountry
      :open="selectCountryDialog"
      @closeSelectCountry="selectCountryDialog = false"
      :type="'/customer/new'"
    />
  </v-card>
</template>
<script>
import SelectCountry from "../Common/SelectCountry";
import StatCard from "@/components/Common/StatCard";
export default {
  components: {
    SelectCountry,
    StatCard,
  },
  props: ["dashboard"],
  data() {
    return {
      selectCountryDialog: false,
      operationName: "",
    };
  },
  methods: {},
};
</script>
<style scoped>
.accounts-dashboard-card {
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.accounts-stats-grid {
  background: #ffffff;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));
  padding: 16px 28px;
}

.accounts-stat-card {
  background: #ffffff;
  border: 1px solid #ebe9e2;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(26, 25, 22, 0.04);
  min-height: 78px;
  padding: 13px 14px 12px 56px;
  position: relative;
}

.accounts-stat-card::before {
  display: none;
}

.accounts-stat-icon {
  align-items: center;
  background: #fff3e6;
  border-radius: 8px;
  display: flex;
  height: 32px;
  justify-content: center;
  left: 14px;
  position: absolute;
  top: 14px;
  width: 32px;
}

.accounts-stat-icon .v-icon {
  color: #b95d07;
  font-size: 18px;
}

.accounts-stat-card--ongoing::before,
.accounts-stat-card--ongoing .accounts-stat-icon {
  background: #2563eb;
}

.accounts-stat-card--ongoing .accounts-stat-icon .v-icon {
  color: #ffffff;
}

.accounts-stat-card span {
  color: #657084;
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.accounts-stat-card strong {
  color: #172033;
  display: block;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  margin-top: 5px;
}

.accounts-stat-card small {
  color: #94a3b8;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}

.dashboard {
  padding: 20px;
  margin: 0 auto;
}
.breakword {
  padding: 10px;
}
.p-b-0 {
  padding-bottom: 0 !important;
}

.f-16 {
  font-size: 16px !important;
}

@media (max-width: 760px) {
  .accounts-stats-grid {
    grid-template-columns: 1fr;
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
